import { Button, EmptyState as EmptyStateView } from '@teach/ui'
import { Plus } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import type { FilterId } from './ListFilters'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  filter: FilterId
  isAuthor: boolean
}

const emptyTitle = (m: (typeof messages)['ru'], filter: FilterId): string =>
  ({ all: m.emptyAll, drafts: m.emptyDrafts, public: m.emptyPublic, link: m.emptyLink })[filter]

export const EmptyState = ({ filter, isAuthor }: Props) => {
  const navigate = useNavigate()
  const m = useMessages(messages)
  const showCreate = isAuthor && filter === 'all'

  return (
    <EmptyStateView
      className="py-0"
      title={emptyTitle(m, filter)}
      action={
        showCreate ? (
          <Button onClick={() => navigate('/instructions/new')}>
            <Plus className="h-4 w-4 mr-2" />
            {m.createFirst}
          </Button>
        ) : undefined
      }
    />
  )
}
